/**
 * Storage abstraction.
 *
 * On the web this is a thin wrapper over localStorage.
 * For React Native port, replace with AsyncStorage — that is the
 * ONLY file that needs to change.
 *
 * Every caller MUST go through this module, not touch localStorage directly.
 */

const PREFIX = 'b2b.';

export const storage = {
  get(key: string): string | null {
    try {
      return localStorage.getItem(PREFIX + key);
    } catch {
      return null;
    }
  },

  set(key: string, value: string): void {
    try {
      localStorage.setItem(PREFIX + key, value);
    } catch {
      // quota exceeded or disabled — ignore
    }
  },

  remove(key: string): void {
    try {
      localStorage.removeItem(PREFIX + key);
    } catch {
      // ignore
    }
  },

  clear(): void {
    try {
      const keys = Object.keys(localStorage).filter((k) => k.startsWith(PREFIX));
      keys.forEach((k) => localStorage.removeItem(k));
    } catch {
      // ignore
    }
  },
};

export const StorageKeys = {
  ACCESS_TOKEN:  'accessToken',
  REFRESH_TOKEN: 'refreshToken',
  CURRENT_USER:  'currentUser',
  APP_SETTINGS:  'appSettings',
} as const;
